import { render, staticRenderFns } from "./registered-number.vue?vue&type=template&id=56417ea9&scoped=true&"
import script from "./registered-number.vue?vue&type=script&lang=js&"
export * from "./registered-number.vue?vue&type=script&lang=js&"
import style0 from "./registered-number.vue?vue&type=style&index=0&id=56417ea9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56417ea9",
  null
  
)

export default component.exports